import { render } from "./PasserelleVtcTaxi.vue?vue&type=template&id=9ddf0e1e"
import script from "./PasserelleVtcTaxi.vue?vue&type=script&lang=js"
export * from "./PasserelleVtcTaxi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__